let storedStore;
export const getStoreInstance = () => storedStore;
export const setStoreInstance = (s) => { storedStore = s; };
